import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListUser = async () => {
  const response = await api.get("/master/user/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterUserPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listUser"],
    queryFn: getListUser,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
